module.exports = __webpack_public_path__ + "src/assets/img/Amphibolurus_muricatus2_small.2ece6168.jpg";